import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { useAdmin, useAdminParams } from 'utils/helpers';
import { Notification } from 'utils/types';
import { AxiosError } from 'axios';

import c from '../utils/constants';
import { notificationsTransformer } from '../transformers';

export default function useGetNotifications(
  params: Record<string, any> | null,
) {
  const { state } = useProvider();
  const args = state;
  const { isAdmin } = useAdmin();
  const { accountId, accountUserId } = useAdminParams();

  return useQuery<Notification[], AxiosError>({
    queryKey: [c.NOTIFICATIONS, params],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/notifications',
            params,
            transformer: notificationsTransformer.notifications,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/notifications`,
            params,
            transformer: notificationsTransformer.notifications,
          },
        }),
      );

      return data?.data;
    },
    // do not get notification if on super admin page
    enabled: !!params && (isAdmin ? !!accountId && !!accountUserId : true),
    retry: 1,
  });
}
